import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { formatCount } from '../../format'

/** The server's page size. Mirrors DefaultPagination on the API. */
const PAGE_SIZE = 50

interface Props {
  page: number
  /** Total matching rows, from the response envelope. */
  count: number
  onChange: (page: number) => void
  pageSize?: number
}

/**
 * Paging, and — more importantly — the total.
 *
 * The total is the part that matters. Several of these lists used to be
 * silently truncated, so an operator scrolling to the bottom of fifty rows had
 * no way to tell a complete answer from a cut-off one. Saying «۱۲۷ مورد»
 * above the table makes that distinction visible even before anyone reaches
 * for a page number.
 */
export function Pager({ page, count, onChange, pageSize = PAGE_SIZE }: Props) {
  const pages = Math.ceil(count / pageSize)

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ mt: 2, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}
    >
      <Typography variant="body2" color="text.secondary">
        {formatCount(count)} مورد
      </Typography>
      {pages > 1 ? (
        <Pagination
          page={page}
          count={pages}
          onChange={(_event, next) => onChange(next)}
          size="small"
          shape="rounded"
          // The list reads right to left; so should its pages.
          dir="rtl"
        />
      ) : null}
    </Stack>
  )
}
